export default __webpack_public_path__ + "static/media/bice-vida-success.549cb6ee.png";